var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vgsi_panel_btn" }, [
    _c("div", { staticClass: "vgsi_btn" }, [
      _c(
        "a",
        {
          staticClass: "vgsi_btn_link",
          attrs: { href: "#", title: "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.clickHandle()
            }
          }
        },
        [_c("span", [_vm._t("default")], 2)]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vgsi_btn__label" }, [
      _vm._v(_vm._s(_vm.propButtonLabel))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }